import { Component, OnDestroy } from '@angular/core';
import { NavController, AlertController, ToastController, ViewController, ModalController } from 'ionic-angular';
import { Storage } from '@ionic/storage';
import { TranslateService } from '@ngx-translate/core';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import { provider } from '../../../providers/provider';
import { HttpClient } from '@angular/common/http';
import { Subject } from 'rxjs';
import { ModalPrivacyPage } from '../modalPrivacy/modalPrivacy';
import { CustomizerProvider } from '../../../providers/customizer/customizer';

import { MenuPage } from '../../menu/menu';

@Component({
  selector: 'page-customerRegistration',
  templateUrl: 'customerRegistration.html'
})
export class CustomerRegistrationPage implements OnDestroy {
  private form: FormGroup;
  private pendingCall = false;
  url: string;
  private _onDestroy = new Subject();
  emailValidation = false;
  privacy1: string;
  privacy2: string;
  privacy3: string;
  data: any;

  constructor(public navCtrl: NavController,
    public translateService: TranslateService,
    public storage: Storage,
    public toastCtrl: ToastController,
    public alertCtrl: AlertController,
    public provider: provider,
    public viewCtrl: ViewController,
    private formBuilder: FormBuilder,
    public modalCtrl: ModalController,
    public http: HttpClient,
    public customizer: CustomizerProvider) {

    this.url = provider.getUrl();
    this.data = provider.getMenu();

    this.form = this.formBuilder.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      telephone: ['', Validators.required],
      email: ['', Validators.compose([Validators.required, Validators.email])],
      password: ['', Validators.compose([Validators.required, Validators.minLength(5)])],
      confirmPassword: ['', Validators.compose([Validators.required])],
      general: [false, Validators.compose([Validators.required,Validators.pattern('true')])],
      marketing: [false],
      profiling: [false],
    }, { validator: CustomerRegistrationPage.passwordsMatch });

  }

  ngOnDestroy() {
    this._onDestroy.next();
  }

  static passwordsMatch(cg: FormGroup): { [err: string]: any } {
    let pwd1 = cg.get('password');
    let pwd2 = cg.get('confirmPassword');
    let rv: { [error: string]: any } = {};
    if ((pwd1.touched || pwd2.touched) && pwd1.value !== pwd2.value) {
      rv['passwordMismatch'] = true;
    }
    return rv;
  }

  registerWithCall() {
    let form = this.form.value;
    form.addresses = [];
    form.privacy = { general: form.general, marketing: form.marketing, profiling: form.profiling }
    delete form.general;
    delete form.marketing;
    delete form.profiling;
    this.provider.verifyEmail(form.email).takeUntil(this._onDestroy).subscribe((response) => {
      let resp = JSON.parse((<any>response)._body);
      if (!resp.success) {
        this.emailValidation = true;
        return;
      } else {
        // togli l'errore
        this.emailValidation = false;
        this.pendingCall = true;    
        this.storage.get('fcmID').then((token) => {
          form.fcmID = token;
          this.provider.phoneCall(form).takeUntil(this._onDestroy).subscribe(() => {
            this.showPrompt();
            this.pendingCall = false;    
          }, err => {
            // show translated error message
            this.handleError(err._body);
            this.pendingCall = false;    
          });
        },
        (err) => {
          this.pendingCall = false;
        });
      }
    }, (error) => {
      console.log(error)
    })
  }

  registerWithSMS() {
    let form = this.form.value;
    form.addresses = [];
    form.privacy = { general: form.general, marketing: form.marketing, profiling: form.profiling }
    delete form.general;
    delete form.marketing;
    delete form.profiling;
    this.provider.verifyEmail(form.email).takeUntil(this._onDestroy).subscribe((response) => {
      let resp = JSON.parse((<any>response)._body);
      if (!resp.success) {
        this.emailValidation = true;
        this.pendingCall = true;    
        return;
      } else {
        // togli l'errore
        this.emailValidation = false;
        this.storage.get('fcmID').then((token) => {
          form.fcmID = token;
          this.provider.phoneSMS(form).takeUntil(this._onDestroy).subscribe(() => {
            this.showPromptSMS();
            this.pendingCall = false;
          }, err => {
            // show translated error message
            this.handleError(err._body);
            this.pendingCall = false;
        });
        },
        (err) => {
          this.pendingCall = false;
          console.log(err);
        });
      }
    }, (error) => {
      this.pendingCall = false;
      console.log(error)
    })
  }

  showPrompt() {
    let count = 31;
    let prompt = this.alertCtrl.create({
      enableBackdropDismiss: false
    });
    let timer = setInterval(msg, 1000);

    function msg() {
      prompt.setMessage('Riceverai una chiamata dal numero 0376/940842. Inserisci il codice di conferma che ti è stato dettato durante la chiamata <br><br> ' + count-- );
    }
    
    prompt.setTitle('Inserisci il codice');
    
    prompt.addInput({
      name: 'code',
      placeholder: '12345',
      type: 'number'
    })
    
    setTimeout(function(){ 
      clearInterval(timer);
      prompt.setMessage('Riceverai una chiamata dal numero 0376/940842. Inserisci il codice di conferma che ti è stato dettato durante la chiamata' );
      prompt.addButton({ text: 'Annulla' });
    }, 30000);

    prompt.addButton({
      text: 'Invia',
      handler: data => {
        this.provider.register(data.code)
          .map(res => res.json())
          .takeUntil(this._onDestroy)
          .subscribe(data => {
            console.log(data);
            this.storage.set('customer', JSON.stringify(data));
            let toast = this.toastCtrl.create({
              message: 'La registrazione è andata a buon fine',
              duration: 3000
            });
            this.provider.setFirstOrder(true);
            toast.present();
            this.navCtrl.push(MenuPage);
          },
            err => {
              console.log(err);
              let toast = this.toastCtrl.create({
                message: 'Il codice inserito è errato! Riprova',
                duration: 3000
              });
              toast.present();
              // show translated error message
              this.handleError(err._body);
            });
      }
    })

    prompt.present();
  }

  showPromptSMS() {
    let count = 31;
    let prompt = this.alertCtrl.create({
      enableBackdropDismiss: false
    });
    let timer = setInterval(msg, 1000);

    function msg() {
      prompt.setMessage('Riceverai tramite messaggio il codice di conferma <br><br> ' + count-- );
    }
    
    prompt.setTitle('Inserisci il codice');
    
    prompt.addInput({
      name: 'code',
      placeholder: '12345',
      type: 'number'
    })
    
    setTimeout(function(){ 
      clearInterval(timer);
      prompt.setMessage('Riceverai tramite messaggio il codice di conferma' );
      prompt.addButton({ text: 'Annulla' });
    }, 30000);

    prompt.addButton({
      text: 'Invia',
      handler: data => {
        this.provider.register(data.code)
          .map(res => res.json())
          .takeUntil(this._onDestroy)
          .subscribe(data => {
            console.log(data);
            this.storage.set('customer', JSON.stringify(data));
            let toast = this.toastCtrl.create({
              message: 'La registrazione è andata a buon fine',
              duration: 3000
            });
            this.provider.setFirstOrder(true);
            toast.present();
            this.navCtrl.push(MenuPage);
          },
            err => {
              console.log(err);
              let toast = this.toastCtrl.create({
                message: 'Il codice inserito è errato! Riprova',
                duration: 3000
              });
              toast.present();
              // show translated error message
              this.handleError(err._body);
            });
      }
    })
    
    prompt.present();
  }

  // Handle error shows a translated error messages
  // if message is an error-coded one, or a generic message
  handleError(message: string) {
    var translatedMessage : string;
    if (!message.startsWith("E") || message.length != 5) {
      message = 'E9999';
    } 
    this.translateService
      .get(message)
      .takeUntil(this._onDestroy)
      .subscribe(value => { translatedMessage = value });                     
    let toast = this.toastCtrl.create({
      message: translatedMessage,
      duration: 3000
    });
    toast.present();
  }

  privacy() {
    const modal = this.modalCtrl.create(ModalPrivacyPage);
    modal.present();
  }

  dismiss() {
    this.viewCtrl.dismiss();
  }

}



// WEBPACK FOOTER //
// ./src/pages/account/customerRegistration/customerRegistration.ts